import React from 'react';
import Hero from './components/Hero';
import ResearchAreas from './components/ResearchAreas';
import Publications from './components/Publications';
import ResearchImpact from './components/ResearchImpact';
import CollaborationCTA from './components/CollaborationCTA';
import ResearchTeam from './components/ResearchTeam';

export default function Research() {
  return (
    <div className="bg-white">
      <Hero />
      <ResearchAreas />
      <Publications />
      <ResearchImpact />
      <ResearchTeam />
      <CollaborationCTA />
    </div>
  );
}